import $ from 'jquery'

const TAB = 9
const ENTER = 13

export default class LiveInputsTextInput {
  constructor(liveInputs) {
    this.liveInputs = liveInputs
    this.handleInputFocus = this.handleInputFocus.bind(this)
    this.handleKeydownEvent = this.handleKeydownEvent.bind(this)
    this.tabDirection = 0
    this.initializeListeners()
  }

  inputFilter() {
    return "[data-behaviour~='live-inputs-text-input']"
  }

  initializeListeners() {
    this.liveInputs.on('keydown', this.inputFilter(), this.handleKeydownEvent)
    this.liveInputs.on('paste', this.inputFilter(), this.handleKeydownEvent)
    this.liveInputs.on('focus', this.inputFilter(), this.handleInputFocus)
    this.liveInputs.on('blur', this.inputFilter(), (event) => {
      this.update($(event.target))
      return this.liveInputs.removeNamespaceSelectedClass()
    })
  }

  handleInputFocus(event) {
    return this.liveInputs.focus($(event.target))
  }

  handleKeydownEvent(event) {
    const $input = $(event.target)
    this.initializeOriginalValue($input)

    if (
      $input.val() !== $input.data('originalValue') &&
      (event.which === TAB || event.which === ENTER)
    ) {
      const doneEditing = $input.is('textarea')
        ? event.which === TAB || (event.which === ENTER && event.metaKey)
        : true

      if (doneEditing) {
        this.updateTabDirection(event)

        this.update($input)
      }
    }

    return this.liveInputs.resizeInput($input, true)
  }

  teardown() {
    this.liveInputs.off('keydown', this.inputFilter(), this.handleKeydownEvent)
    this.liveInputs.off('focus', this.inputFilter(), this.handleInputFocus)
  }

  update($input) {
    this.initializeOriginalValue($input)
    if ($input.val() !== $input.data('originalValue')) {
      $input.data('originalValue', $input.val())
      return this.liveInputs.update($input)
    }
  }

  updateTabDirection(event) {
    const tabDirection = event.shiftKey ? -1 : 1
    return this.liveInputs.setTabDirection(tabDirection)
  }

  initializeOriginalValue($input) {
    if ($input.data('originalValue') === undefined) {
      return $input.data('originalValue', $input.val())
    }
  }
}
